import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/ars-color-lockup.svg")